<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div id="page-policies">
    <div class="container">
      <h1>智生活隱私權政策</h1>
      <p>智生活（以下稱「本服務」）係由智生活科技股份有限公司(以下稱「本公司」)提供社區住戶e化便利生活所開發之網頁，本公司謹以下列聲明，向所有客戶說明本服務隱私權保護政策。</p>
      <p>為保障您使用本服務之隱私權，請您仔細閱讀以下本服務所制訂之隱私權政策(以下稱「本政策」)，根據本服務要求所提供的個人資訊，本公司將根據本政策來保護，但經由本服務連結之網站，均有其專屬之隱私權政策，當使用者在這些網站進行活動時，有關個人資料之保護，將適用各該網站的隱私權政策，本公司不為其行為負責，使用者在使用本服務、瀏覽本服務或參加本服務活動時，網頁會自動接收紀錄使用者瀏覽器上的伺服器，包括但不限於IP位置、Cookie及使用者的點選記錄。</p>
      <p>本公司將依本政策，適當管理使用本服務所蒐集之您的個人資料，以下本政策將幫助您了解，我們如何蒐集、處理、利用、保護個人資料以及我們告知個人資料的對象，請詳閱以下內容：</p>
      <ul>
        <li>
          <h2>一、個人資料蒐集及利用</h2>
          <p>依照個人資料保護法第八條規定，對於客戶資料之蒐集、處理、利用等，須告知您相關事項如下，請詳閱：</p>
          <ul>
            <li>(一) 蒐集目的：本公司為商業與技術資訊、社區及本公司客戶管理、會員管理、行銷、資訊與資料庫管理、統計調查與分析、其他合於營業登記項目或章程所定業務之需要等目的，蒐集並於下述目的範圍內利用您所提供之個人資料：040 行銷、090 消費者、客戶管理與服務、098 商業與技術資訊、135 資(通)訊服務、136 資(通)訊與資料庫管理、137 資通安全與管理、148 網路購物及其他電子商務服務、150 輔助性與後勤支援管理、157 調查、統計與研究分析、173 其他公務機關對目的事業之監督管理、176 其他自然人基於正當性目的所進行個人資料蒐集處理及利用</li>
            <li>(二) 蒐集類別：C001 辨識個人者。(如：姓名、地址、室內電話號碼、行動電話、通訊及戶籍地址、電子郵遞地址、影像擷取之紀錄、提供網路身分認證或申辦查詢服務之紀錄及其他任何可辨識資料本人者等。)、C011 個人描述。(如：年齡、性別、出生年月日、出生地、國籍等。)、C031住家及設施。(如：住所地址、設備之種類、所有或承租、住用之期間、租金或稅率及其他花費在房屋上之支出、房屋之種類、價值及所有人之姓名等。)、C032財產。(如：所有或具有其他權利之動產或不動產等。)、C101資料主體之商業活動。(如：商業種類、提供或使用之財貨或服務、商業契約等。)、C102 約定或契約。(如：關於交易、商業、法律或其他契約、代理等。)、C132 未分類之資料。(如：無法歸類之信件、檔案、報告或電子郵件等。)</li>
            <li>
              (三) 利用期間、地區、對象及方式：
              <ul>
                <li>1.期間：使用者要求停止使用或本公司停止提供服務之日為止。</li>
                <li>2.地區：在中華民國境內之本公司、關係企業、相關委外之協力廠商(如：供應商、下包商等廠商)所使用伺服器主機所在地及相關服務或商品發行或行銷地區。</li>
                <li>
                  3.利用對象及方式：當您為本公司客戶時，本公司基於服務之提供而取得您的基本資料，為提供您更完善、多元的服務以及更好之服務品質，我們將會在法令許可或您同意下，僅將您的資料使用在您所需的個別服務、學術研究、其他諮詢、顧問服務及本公司所舉辦的行銷活動上，以提供您所需的行銷活動及相關優惠訊息給您，例示如下：
                  <ul>
                    <li>(1)使用者綁定帳號後，可於本服務功能查詢個人資料。</li>
                    <li>(2)宣傳廣告或行銷等：提供使用者各種活動資訊將透過本服務訊息通知功能、電子郵件、郵件、電話或簡訊等提供與服務有關之資訊，訊息通知功能提供使用者優惠訊息、行銷活動等各種公告或合作廠商合作活動通知，欲拒絕相關訊息通知，可利用本服務之訊息通知功能設定關閉，如關閉通知後，可能會無法收到本公司發布訊息或享有完整功能服務。</li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <br>
        <li>
          <h2>二、個人資料揭露對象</h2>
          <p>本公司絕對不會任意出售、交換、出租或以其他變相之方式，將您的個人資料揭露與其他團體或個人。惟有下列三種情形，本公司會與第三者共用您的個人資料。</p>
          <ul>
            <li>(一) 經過您的事前同意或授權允許時。</li>
            <li>(二) 司法單位或其他主管機關經合法正式的程序要求時。</li>
            <li>(三) 為提供您其他服務或優惠權益，需要與提供該服務或優惠之第三者共用您的資料時，我們會在活動時提供充分說明並告知，您可以自由選擇是否接受這項服務或優惠。</li>
          </ul>
        </li>
        <br>
        <li>
          <h2>三、依個人資料保護法第三條規定，您得就其所提供之個人資料行使下列權利：</h2>
          <p>查詢或請求閱覽、請求製給複製本、請求補充或更正、請求停止蒐集、處理或利用及請求刪除，您如欲行使上述權利，可與本服務客服連絡進行申請。</p>
        </li>
        <br>
        <li>
          <h2>四、使用者權限</h2>
          <ul>
            <li>(一) 您可隨時於本服務上確認個人資料，若您的個人資料有變更、或發現個人資料不正確，可以向本公司要求修改或更正。</li>
            <li>(二) 您亦可要求本公司刪除、停止處理或利用您的個人資料。本公司將僅於法令許可之範圍內繼續保留、處理及利用您的個人資料。</li>
            <li>(三) 您可自由選擇是否提供某些個人資料予本公司，惟若您未提供該等資料或提供給本公司的資料不完全，您可能無法使用本服務之部分功能。如選擇不提供影像擷取之紀錄，請於領取包裹及寄放物品時告知操作系統之管理人員，請管理人員鏡頭拍攝他處即可。</li>
          </ul>
        </li>
        <br>
        <li>
          <h2>五、個人資料安全</h2>
          <p>本公司將採取適當安全防護措施以防止未經您授權的接近使用、變更、重製、揭露、或刪除您的個人資料或您於本服務中之互動資料。但請注意，您的個人資料仍有可能因本公司的安全防護措施遭破壞而發生上述情事。</p>
        </li>
        <br>
        <li>
          <h2>六、本政策修訂</h2>
          <p>本公司保留隨時修訂本政策之權利，本公司會將修訂之內容放置於本服務-隱私權政策上，以便您的查閱，如您繼續使用本服務，將視為您已同意本公司對於本政策之修訂。本公司保留於任何時點，不經通知隨時修改或暫時或永久停止繼續提供本服務(或其任一部分)的權利，不另行個別通知，使用者可以隨時在本服務上詳閱修訂後的隱私權聲明及其相關告知事項。</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  head () {
    return {
      title: '智生活隱私權政策',
      meta: [
        { hid: 'robots', name: 'robots', content: 'noindex' },
        { hid: 'googlebot', name: 'googlebot', content: 'noindex' }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  max-width: 1000px;
  padding-top: 40px;
  padding-bottom: 40px;
}
h1 {
  margin-bottom: 20px;
  font-weight: bold;
  font-size: pxTorem(26px);
  line-height: pxTorem(30px);
  text-align: center;
}
h2 {
  font-weight: bold;
}

/** 手機 */
@media screen and (max-width: $mobileWidth) {
  .container {
    padding-left: 15px;
    padding-right: 15px;
  }
  ul {
    padding-left: 15px;
  }
}
</style>
